import { ref, onBeforeUnmount } from '@vue/composition-api'

// The result of an action on one table row, shown right above that row (see RowAlert.vue) instead
// of at the top of the page. Auto-dismisses after 5s unless `persistent`; every call gets a new id
// so repeating an action with the same text re-creates the message and is visibly "new".
export default function useRowAlert() {
  const empty = () => ({ message: null, type: 'success', rowId: null, id: 0 })
  const alert = ref(empty())
  let seq = 0
  let timer = null

  function clear() {
    clearTimeout(timer)
    alert.value = empty()
  }

  function show(message, type, rowId, { persistent = false } = {}) {
    clearTimeout(timer)
    alert.value = { message, type, rowId, id: ++seq }
    if (!persistent) timer = setTimeout(clear, 5000)
  }

  onBeforeUnmount(() => clearTimeout(timer))

  return {
    alert,
    show,
    clear,
    showSuccess: (message, rowId) => show(message, 'success', rowId),
    showError: (message, rowId, options) => show(message, 'warning', rowId, options)
  }
}



// WEBPACK FOOTER //
// ./src/composables/useRowAlert.js